import { Box, Heading } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect, useState } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { usePageLogger } from '../../../bi/mfi'
import { useStorageContext } from '../../../context/StorageContext/StorageContext'
import { Button } from '../../reusable/Button'
import { WixStudioLogoWithBack } from '../../reusable/WixStudioLogoWithBack'
import { TWixStudioVelo as Content } from './WixStudioVelo.content'
import { wixStudioVeloDataHooks as dataHooks } from './WixStudioVelo.dataHooks'
import s from './WixStudioVelo.scss'

export const WixStudioVelo: FC = () => {
  const [isButtonClicked, setIsButtonClicked] = useState(false)
  const { save } = useStorageContext()
  const { content } = useContent<Content>()
  const [pageLoading] = usePageLoading()
  const pageLogger = usePageLogger()
  const next = useNext()
  const questionContent = content.question.content
  const questionOptions = content.question.options

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  const handleBtnClick = (optionKey: string) => async () => {
    if (pageLoading || isButtonClicked) {
      return
    }
    setIsButtonClicked(true)
    void pageLogger.answer({ answer: optionKey })
    save({ isWixStudioAccount: true })
    await markAsWixStudioAccount()
    next({
      [content.question.questionKey]: { values: [optionKey] },
    })
  }

  return (
    <>
      <Box
        height="100vh"
        background="linear-gradient(180deg, rgba(197, 215, 247, 0.70) 25.43%, rgba(218, 215, 227, 0.70) 55.51%, rgba(243, 244, 225, 0.70) 100%)"
        align="center"
        verticalAlign="middle"
      >
        <WixStudioLogoWithBack />
        <Box margin="0 12%" direction="vertical" align="center">
          <Box direction="vertical" align="center" gap="SP6" textAlign="center">
            <Heading as="h1" className={s.title} dataHook={dataHooks.title()}>
              {questionContent.title}
            </Heading>
            <Box width="586px">
              <Heading className={s.subtitle} dataHook={dataHooks.subtitle()}>
                {questionContent.subtitle}
              </Heading>
            </Box>
          </Box>
          <Box marginTop="45px">
            {questionOptions.map(option => (
              <Button
                key={option.optionKey}
                isLoading={isButtonClicked}
                skin="dark"
                priority={option.primary ? 'primary' : 'secondary'}
                onClick={handleBtnClick(option.optionKey)}
                dataHook={dataHooks.item({ key: option.optionKey })}
                label={option.title}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </>
  )
}
